import {
    LIST_AUDIENCE_CATEGORIES,
    LIST_AUDIENCE_CATEGORIES_SUCCESS,
    LIST_AUDIENCE_CATEGORIES_ERROR,
    ADD_AUDIENCE_CATEGORIES,
    SAVE_AUDIENCE_CATEGORIES,
    SAVE_AUDIENCE_CATEGORIES_SUCCESS,
    SAVE_AUDIENCE_CATEGORIES_ERROR,
    DELETE_AUDIENCE_CATEGORIES,
    DELETE_AUDIENCE_CATEGORIES_SUCCESS,
    DELETE_AUDIENCE_CATEGORIES_ERROR,
    EDIT_AUDIENCE_CATEGORIES,
    UPDATE_AUDIENCE_CATEGORIES,
    UPDATE_AUDIENCE_CATEGORIES_SUCCESS,
    UPDATE_AUDIENCE_CATEGORIES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import audienceCategoriesData from '../data/audienceCategories';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'categoria';

//LISTAR AUDIENCE CATEGORYS
export function listAudienceCategoriesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listAudienceCategories() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const audienceCategories = response.data;
            //const audienceCategories = audienceCategoriesData;
            //Llamo al dispatch
            dispatch( listAudienceCategoriesSuccess(audienceCategories.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listAudienceCategoriesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listAudienceCategories = () => ({
    type: LIST_AUDIENCE_CATEGORIES,
    payload: true
});

const listAudienceCategoriesSuccess = audienceCategories => ({
    type: LIST_AUDIENCE_CATEGORIES_SUCCESS,
    payload: audienceCategories
});

const listAudienceCategoriesError = error => ({
    type: LIST_AUDIENCE_CATEGORIES_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addAudienceCategoriesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addAudienceCategories(false) );
        //Abro el formulario
        showForm();
    }
}

const addAudienceCategories = isEdit => ({
    type: ADD_AUDIENCE_CATEGORIES,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveAudienceCategoriesAction(audienceCategory, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveAudienceCategories() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, audienceCategory);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveAudienceCategoriesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveAudienceCategoriesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveAudienceCategories = () => ({
    type: SAVE_AUDIENCE_CATEGORIES,
    payload: true
});


const saveAudienceCategoriesSuccess = audienceCategory => ({
    type: SAVE_AUDIENCE_CATEGORIES_SUCCESS,
    payload: audienceCategory
});

const saveAudienceCategoriesError = error => ({
    type: SAVE_AUDIENCE_CATEGORIES_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editAudienceCategoriesAction(audienceCategory, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editAudienceCategories(audienceCategory) );
        //Abro el formulario
        showForm();
    }
}

const editAudienceCategories = audienceCategory => ({
    type: EDIT_AUDIENCE_CATEGORIES,
    payload: audienceCategory
});

//UPDATE AUDIENCE CATEGORY
export function updateAudienceCategoriesAction(audienceCategory, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateAudienceCategories() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${audienceCategory.id}`, audienceCategory);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateAudienceCategoriesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateAudienceCategoriesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateAudienceCategories = () => ({
    type: UPDATE_AUDIENCE_CATEGORIES,
    payload: true
});

const updateAudienceCategoriesSuccess = audienceCategory => ({
    type: UPDATE_AUDIENCE_CATEGORIES_SUCCESS,
    payload: audienceCategory
});

const updateAudienceCategoriesError = error => ({
    type: UPDATE_AUDIENCE_CATEGORIES_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteAudienceCategoriesAction(audienceCategory) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteAudienceCategories() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${audienceCategory.id}`);
            const response = await clienteAxios.put(`/${controller}/${audienceCategory.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteAudienceCategoriesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteAudienceCategoriesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteAudienceCategories = () => ({
    type: DELETE_AUDIENCE_CATEGORIES,
    payload: true
});

const deleteAudienceCategoriesSuccess = audienceCategory => ({
    type: DELETE_AUDIENCE_CATEGORIES_SUCCESS,
    payload: audienceCategory
});

const deleteAudienceCategoriesError = error => ({
    type: DELETE_AUDIENCE_CATEGORIES_ERROR,
    payload: error
});